import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import StructureZoomService from '@Services/StructureZoom';
import ResultCheckboxNew from '@Pages/Results/Containers/ResultCheckboxContainer';
import ResultRenderer from '@Components/Results/result-renderer.service';
import PxValueComponent from '@Components/Results/substances/px-value.component';
import { citations } from '@Constants';
import { CITATION_LINKS_TRACKING_INDEX_MARKER } from '@Components/Results/analytics/citationLinksTracking';

export default class ResultComponent extends React.Component {
  static contextItemClass = {
    substances: 'substance',
    reactions: 'reaction',
    tgitems: 'target',
    citations: 'document',
  };

  constructor(props) {
    super(props);

    this.spinnerId = `rx-element-${props.context}-${props.result.index}`;
    // IMHO Currently it is optimal solution - to listen for zoom just in one place, and then let React handle changes
    // Might make sense to change this if we will have centralized state management
    this.state = { zoom: StructureZoomService.subscribe(props.context, this.zoomHandler, true) };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { result, gridView } = this.props;
    const { zoom } = this.state;
    return (!result && nextProps.result) || zoom !== nextState.zoom || gridView !== nextProps.gridView;
  }

  componentWillUnmount() {
    const { context } = this.props;
    StructureZoomService.unsubscribe(context, this.zoomHandler);
  }

  zoomHandler = (zoom) => {
    this.setState({ zoom });
  };

  render() {
    const { zoom } = this.state;
    const { context, updateItemChecked, ...otherProps } = this.props;
    const { spinnerId } = this;
    const { contextItemClass } = this.constructor;

    return (
      <article
        className={`rx-element rx-element--${contextItemClass[context]}`}
        {...(context === citations && CITATION_LINKS_TRACKING_INDEX_MARKER.citationsResultItem)}>
        {!otherProps.hideCheckbox && <ResultCheckboxNew result={otherProps.result} context={context} />}

        {ResultRenderer.render(context, { zoom, spinnerId, ...otherProps })}

        {/* eslint-disable-next-line no-restricted-globals */}
        {!isNaN(otherProps.result.px) && (
          <PxValueComponent
            pxValue={otherProps.result.px}
            pxColor={otherProps.result.pxColor}
            cellOperation={otherProps.result.cellOperation}
          />
        )}
        <RxSpinnerComponent spinnerId={spinnerId} />
      </article>
    );
  }
}

ResultComponent.defaultProps = {
  updateItemChecked: () => {},
};

ResultComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  context: PropTypes.string.isRequired,
  result: PropTypes.object.isRequired,
  gridView: PropTypes.bool,
  updateItemChecked: PropTypes.func,
  hideCheckbox: PropTypes.bool,
  size: PropTypes.number,
};
